import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { HeaderBg, Title, StyledBox } from './style';
import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import CardReportInfo from '../../../components/Campanhas/CardReportInfo';
import { ButtonCampaign } from '../../../components/utilities/styledComponents/ButtonCampaign';
import Leads from '../../../components/Campanhas/Leads';

const LeadReports = () => {
	useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Listagem de relatórios lead',
			},
			dataLayerName: 'Campanhas',
		});
	}, []);

	return (
		<div>
			<HeaderBg style={{ padding: '18px 30px' }}>
				<div className="row align-items-center">
					<div className="col-9 col-xl-6">
						<ContentTitle padding="0 27px" fontSize="32px">Campanhas - Relatórios</ContentTitle>
					</div>
					<div className="col-3 col-xl-6">
						<ButtonCampaign
							type="link"
							to="/campanhas/nova-campanha"
							padding="15px 40px"
						>
							Exportar relatório
						</ButtonCampaign>
					</div>
				</div>
			</HeaderBg>
			<div style={{ padding: '19px 27px 18px' }}>
				<Title>Campanha de lead</Title>
				<div className="row">
					<StyledBox className="col-12 col-lg-4">
						<CardReportInfo
							titleCaps="Leads gerados"
							text="1000"
						/>
					</StyledBox>
					<StyledBox className="col-12 col-lg-4">
						<CardReportInfo
							titleCaps="Leads em negocioção"
							text="800"
						/>
					</StyledBox>
					<StyledBox className="col-12 col-lg-4">
						<CardReportInfo
							titleCaps="Vendas realizadas"
							text="100"
						/>
					</StyledBox>
				</div>
				<div className="row" style={{ marginTop: '30px' }}>
					<div className="col-12">
						<Leads
							fontSize="20px"
							marginBottom="0"
							title="Dados gerais"
							border="none"
							number="1000"
							text="Leads gerados"
							numberTwo="800"
							textTwo="Leads em negociação"
							numberThree="400"
							textThree="Visitas agendadas"
							numberFour="380"
							textFour="Visitas realizadas"
							numberFive="100"
							textFive="Vendas realizadas"
							percentage="8,8%"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
export default LeadReports;
